import { render, staticRenderFns } from "./CreateStrategicValue.vue?vue&type=template&id=b041dbb6&scoped=true"
import script from "./CreateStrategicValue.vue?vue&type=script&lang=js"
export * from "./CreateStrategicValue.vue?vue&type=script&lang=js"
import style0 from "./CreateStrategicValue.vue?vue&type=style&index=0&id=b041dbb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b041dbb6",
  null
  
)

export default component.exports